class VideoPlayer extends HTMLElement {
  constructor() {
    super()

    this.thisbtn = this
    this.screenWidth = window.innerWidth
    this.modal = document.querySelector(`.video-${this.id}`)
    this.span = document.querySelector(`.video-${this.id} .close_modal`)
    this.playButton = document.querySelector(`.video-${this.id} .videoPlay`)
    this.playButtonLarge = document.querySelector(`.video-${this.id} .video_play_button`)
    this.playSvg = document.querySelector(`.video-${this.id} .playSvg`)
    this.pauseButton = document.querySelector(`.video-${this.id} .pauseSvg`)
    this.closebtn = document.querySelector(`.video-${this.id} .videoCloseBtn`)
    this.videoVolume = document.querySelector(`.video-${this.id} .videoVolume`)
    this.videoWrapper = document.querySelector(`.video-${this.id} .video_wrapper`)
    this.modalContent = document.querySelector(`.video-${this.id} .modal-content`)
    this.videoFullscreen = document.querySelector(`.video-${this.id} .videoFullscreen`)
    this.progress = document.querySelector(`.video-${this.id} #progress`)
    this.progressBar = document.querySelector(`.video-${this.id} #progress-bar`)

    this.header = document.querySelector("#customHeader")

    const metafieldVideo = this.hasAttribute('data-metafield')

    if( metafieldVideo == true ){
      const metafieldVideoTag = this.videoWrapper.children[0]
      const bgVideo = this.modalContent.children[1].children[0]
      bgVideo.classList.add('background-video')

      metafieldVideoTag.classList.add('video')
      this.video = document.querySelector(`.video-${this.id} .video`)
    }
    else{
      this.video = document.querySelector(`.video-${this.id} .video`)
    }

    this.backgroundVideo = document.querySelector(`.video-${this.id} .background-video`)

    this.init.bind(this)
    this.close.bind(this)

    if (this.span){
      this.span.addEventListener("click", this.close.bind(this))
      this.thisbtn.addEventListener("click", this.open.bind(this))
      window.addEventListener("click", (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      })
    }

    this.init()
  }

  updateCloseButton() {
    if (this.screenWidth <= "499") {
      this.closebtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="37.477" height="37.477" viewBox="0 0 37.477 37.477">
            <text data-name="+" transform="rotate(45 10.96 26.46)" style="fill:#fff;font-size:30px;font-family:Calibre-Thin,Calibre;font-weight:200;letter-spacing:.045em">
              <tspan x="-7.425" y="20">+</tspan>
            </text></svg>`
    }
  }

  open() {
    this.modal.style.display = "block"
    document.body.classList.add("modalOpen")
    this.header.classList.add("poupOpen")

    const video = this.video
    const backgroundVideo = this.backgroundVideo
    const playSvg = this.playSvg
    const pauseButton = this.pauseButton

    playSvg.style.display = "none"
    pauseButton.style.display = "block"
    if (backgroundVideo) {
      backgroundVideo.play()
    }
    video.play()
  }

  close() {
    const video = this.video
    const backgroundVideo = this.backgroundVideo
    const playSvg = this.playSvg
    const pauseButton = this.pauseButton

    this.header.classList.remove("poupOpen")

    this.modal.style.display = "none"
    document.body.classList.remove("modalOpen")

    playSvg.style.display = "block"
    pauseButton.style.display = "none"
    video.pause()
    backgroundVideo.pause()
    video.currentTime = 0.1
    backgroundVideo.currentTime = 0.1
  }

  init() {
    const video = this.video
    const backgroundVideo = this.backgroundVideo
    const playButton = this.playButton
    const playButtonLarge = this.playButtonLarge
    const playSvg = this.playSvg
    const videoVolume = this.videoVolume
    const videoFullscreen = this.videoFullscreen
    const pauseButton = this.pauseButton
    const progress =  this.progress
    const progressBar =  this.progressBar

    // set the pause button to display:none by default
    if (video.hasAttribute('autoplay')) {
      pauseButton.style.display = "block"
      playSvg.style.display = "none"
    } else {
      pauseButton.style.display = "none"
      playSvg.style.display = "block"
    }

    video.currentTime = 0.1
    if (backgroundVideo) {
      backgroundVideo.currentTime = 0.1
      backgroundVideo.muted = true
    }

    playButtonLarge.addEventListener("click", function () {
      if (video.paused) {
        playButtonLarge.style.display = "none"
        playSvg.style.display = "none"
        pauseButton.style.display = "block"
        if (backgroundVideo) {
          backgroundVideo.play()
        }
        video.play()
      } else {
        playButtonLarge.style.display = "flex"
        playSvg.style.display = "block"
        pauseButton.style.display = "none"
        if (backgroundVideo) {
          backgroundVideo.pause()
        }
        video.pause()
      }
    })

    playButton.addEventListener("click", function () {
      if (video.paused) {
        playSvg.style.display = "none"
        pauseButton.style.display = "block"
        if (backgroundVideo) {
          backgroundVideo.play()
        }
        video.play()
      } else {
        playSvg.style.display = "block"
        pauseButton.style.display = "none"
        if (backgroundVideo) {
          backgroundVideo.pause()
        }
        video.pause()
      }
    })

    videoVolume.addEventListener("click", function () {
      video.muted = !video.muted
      //backgroundVideo.muted = true
      if(video.muted){
        videoVolume.classList.add("inactive")
      }
      else{
        videoVolume.classList.remove("inactive")
      }
    })

    if (videoFullscreen) {
      videoFullscreen.addEventListener("click", function () {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
      })
    }

    video.addEventListener('loadedmetadata', () => {
      progress.setAttribute('max', video.duration)
    })

    video.addEventListener('timeupdate', () => {
      const max = video.duration

      if (!progress.getAttribute('max')) {
        progress.setAttribute('max', max)
      }

      progress.setAttribute("value" , video.currentTime)
      if (video.ended) {
        playSvg.style.display = "block"
        pauseButton.style.display = "none"
      }
      progressBar.style.width = `${Math.floor(video.currentTime * 100 / video.duration)}%`
    })


    progress.addEventListener('click', (e) => {
      const rect = progress.getBoundingClientRect()
      const pos = (e.pageX  - rect.left) / progress.offsetWidth
      video.currentTime = pos * video.duration
      if (backgroundVideo) {
        backgroundVideo.currentTime = pos * video.duration
      }
    })

    window.addEventListener("click", (event) => {
      if (event.target.classList.contains("video_player_wrapper")) {
        this.close()
      }
    })
  }
}

customElements.define("video-player", VideoPlayer)
